// Finishing a game stays on that game's result screen (CLAUDE.md: A finished
// game stays on its result screen) — for every game, present and future.
//
// Nothing navigates when a game ends; the next-game buttons are how a player
// moves on. What this adds is where the result screen opens: **at its top**,
// so the first thing a player sees is the line saying how they did. The board
// is replaced by a taller screen in the same place, and without this the page
// was left wherever the browser put it — which, with scroll anchoring, was the
// foot of the result screen, the next-game button sitting under the thumb that
// had just pressed Submit (`overflow-anchor: none` in base.css is the other
// half). Only a game finished on this visit is moved: a result screen opened
// from a link, a refresh or Play is left exactly where the browser opens it.
import { useLayoutEffect, useRef } from 'react';

export function useResultFromTop(finished: boolean) {
  const wasFinished = useRef(finished);
  useLayoutEffect(() => {
    if (finished && !wasFinished.current) window.scrollTo(0, 0);
    wasFinished.current = finished;
  }, [finished]);
}
